
    import { ref, computed } from 'vue'
    import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
    import { LocationsLayer } from './locationsLayer';
    import { ScenarioLocationsLayer } from './scenarioLocationsLayer';
    import { CatchmentAreaFeatureLayerHelper } from './catchmentAreaFeatureLayerHelper';
    import { AreaLayer } from './areaLayer';
    import { AreasLayer } from './areasLayer';
    import { PoisLayer } from './poisLayer';
    import { PoisInRangeLayer } from './poisInRangeLayer';
    import { IsoLinesLayer } from './isoLinesLayer';
    import { TilesLayer } from './tilesLayer';
    import { GoogleMapsLayer } from './googleMapsLayer';
    import { SearchResultsLayer } from './searchResultsLayer';
    import FooterMenu from './FooterMenu.vue'
    
    import { HereMapsLayer } from './hereMapsLayer';
    import { HeatMapLayer } from './heatMapLayer';        
    import '/node_modules/mapbox-gl/dist/mapbox-gl.css';
    import * as mapboxgl from 'mapbox-gl';
import { ScaleControl } from 'mapbox-gl';

    (mapboxgl as any).accessToken = 'pk.eyJ1IjoiZXZlcnQtZGllcGVyaW5rIiwiYSI6ImNrb2lkc2YzNDAzYmcyb3B2ZHV2d3N6cXIifQ.9CIPydNc_qxZ0rDWfqAy5w';

    @Component({
        components: {
            FooterMenu,
        },
    })
    export default class Mapbox extends Vue {
        @Prop({ default: null }) public legendData: any;
        @Prop({ default: null }) public model: any;
        @Prop({ default: null }) public location: any;
        @Prop({ default: null }) public locations: any;
        @Prop({ default: null }) public pois: any;
        @Prop({ default: null }) public locationCatchmentArea: any;
        @Prop({ default: null }) public catchmentArea: any;
        @Prop({ default: null }) public scenario: any;
        @Prop({ default: null }) public scenarioLocations: any;
        @Prop({ default: null }) public scenarioLocationsVisible: any;
        @Prop({ default: null }) public locationIsoLines: any;
        @Prop({ default: null }) public isoLineSet: any;
        @Prop({ default: null }) public isoLineMinutes: any;
        @Prop({ default: null }) public area: any;
        @Prop({ default: null }) public filter: any;
        @Prop({ default: (() => []) }) public filterLocations: Arra<number>;
        @Prop({ default: null }) public areaSetVisible: any;
        @Prop({ default: null }) public heatMapPoints: any;
        @Prop({ default: null }) public searchResults: any;
        @Prop({ default: null }) public mapFlyTo: any;
        @Prop({ default: null }) public poisInRange: any;
        @Prop({ default: null }) public poisInRangeFieldState: any;
        
        @Prop({ type: Number, default: 0 }) public leftPadding!: number;
        @Prop({ type: Number, default: 0 }) public rightPadding!: number;
        @Prop({ type: Boolean, default: false }) public report!: boolean;
        @Prop({ type: Boolean, default: false }) public showFooterMenu: boolean;
        @Prop({ type: Boolean, default: false }) public animate: boolean;
        
        @Prop({ default: null }) public mapState: any;
        @Prop({ default: false }) public satelliteView: any;
        @Prop({ default: false }) public showLocationOutput: boolean;

        @Prop({ default: null }) public areas: any;

        private locationsLayer: LocationsLayer | null = null;
        private scenarioLocationsLayer: ScenarioLocationsLayer | null = null;
        private poisLayer: PoisLayer | null = null;
        private cachmentAreaLayer: CatchmentAreaFeatureLayerHelper | null = null;
        private isoLinesLayer: IsoLinesLayer | null = null;
        private areaLayer: AreaLayer | null = null;
        private areasLayer: AreasLayer | null = null;
        private tilesLayer: TilesLayer | null = null;
        private googleMapsLayer: GoogleMapsLayer | null = null;
        private hereMapsLayer: HereMapsLayer | null = null;
        private poisInRangeLayer: PoisInRangeLayer | null = null;
        private heatMapLayer: HeatMapLayer | null = null;
        private searchResultsLayer: SearchResultsLayer | null = null;

        private modelChanging: boolean = false;
        public map: any;
        private mapRef = ref(null);
        private scaleControlRef = ref(null);

        private emptyStyle: any = {
            "version": 8,
            "name": "IRIS Platform",
            "metadata": {
                "mapbox:autocomposite": true,
                "mapbox:thumb": "data:image/webp;base64,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",
                "mapbox:uiParadigm": "layers",
                "mapbox:sdk-support": {
                    "js": "3.9.0",
                    "android": "11.11.0",
                    "ios": "11.11.0"
                },
                "mapbox:groups": {},
                "mapbox:uiExpandedImports": ["basemap"],
                "mapbox:uiInteractiveImports": {}
            },
            "center": [-34, 38],
            "zoom": 2,
            "terrain": null,
            "imports": [
                {
                    "id": "basemap",
                    "url": "mapbox://styles/mapbox/standard-satellite",
                    "config": {
                        "showPlaceLabels": false,
                        "showAdminBoundaries": false,
                        "showRoadsAndTransit": false,
                        "showRoadLabels": false,
                        "showTransitLabels": false,
                        "showPointOfInterestLabels": false
                    }
                }
            ],
            "sources": {},
            "sprite": "mapbox://sprites/evert-dieperink/cm85ukujd003q01s87etgfdim/draft",
            "glyphs": "mapbox://fonts/mapbox/{fontstack}/{range}.pbf",
            "projection": { "name": "globe" },
            "layers": [],
            "created": "2025-05-15T10:57:04.179Z",
            "modified": "2025-12-03T09:24:25.274Z",
            "id": "cm85ukujd003q01s87etgfdim",
            "owner": "evert-dieperink",
            "visibility": "private",
            "protected": false,
            "draft": true
        };
        private standardStyle: string = 'mapbox://styles/evert-dieperink/cm85ukujd003q01s87etgfdim';
        private satelliteStyle: string = 'mapbox://styles/evert-dieperink/cm8688so9005f01s8h5fie4xq';

        private mounted() {
            this.onModelChanged();
        }
        public exportToPng() { 
            const canvas = this.map.getCanvas();
            const dataURL = canvas.toDataURL('image/png');

            // Download it
            const link = document.createElement('a');
            link.href = dataURL;
            link.download = this.$t('message.mapExport') + ' ' + this.model.name + ' - ' + this.scenario.name + '.png';
            link.click();
        }


        @Watch('areas')
        private onAreasChanged() {
            this.areasLayer?.DataChanged();
        }

        

        @Watch('satelliteView')
        private onSatelliteViewChanged() {
            this.onModelChanged(true);
        }

        @Watch('showLocationOutput')
        private onShowLocationOutputChanged(value: boolean) {
            this.locationsLayer?.SetOutputLabelsVisible(value);
        }

        @Watch('model')
        private onModelChanged(maintainZoomAndPosition = false) {
            this.modelChanging = true;
            
            
            if (this.mapState.fromQuery == true) maintainZoomAndPosition = true;
            
            const zoom = this.mapState == null || this.mapState.zoom == null ? 8 : this.mapState.zoom;
            const center = this.mapState == null || this.mapState.center == null ? { lng: 4.914908662529424, lat: 52.34830298821911 } : this.mapState.center;
            const pitch = this.mapState == null || this.mapState.pitch == null ? 0 : this.mapState.pitch;
            const bearing =  this.mapState == null || this.mapState.bearing == null ? 0 : this.mapState.bearing;
            if (this.map) this.map.remove();
            const _warn = console.warn.bind(console);
            console.warn = (...args: any[]) => {
                if (typeof args[0] === 'string' && args[0].includes('featureNamespace') && args[0].includes('place-labels')) return;
                _warn(...args);
            };
            this.map = new mapboxgl.Map({
                container: this.$refs.mapBoxContainer as HTMLElement,
                style: this.model.mapProvider != 1 ? this.emptyStyle : (this.satelliteView ? this.satelliteStyle : this.standardStyle),
                center: center,
                zoom: zoom,
                pitch: pitch,
                bearing: bearing,
                attributionControl: false,
                antialias: true,
                preserveDrawingBuffer: true,
                worldview: this.model.worldview,
                language: this.model.language
            });

            

            this.mapRef = computed(() => this.map);
            const scaleControl: ScaleControl = new mapboxgl.ScaleControl({
                maxWidth: 200,
                unit: 'metric',
            });
            this.map.addControl(scaleControl, 'bottom-left');
            this.scaleControlRef = computed(() => scaleControl);

            this.map.addControl(new mapboxgl.AttributionControl({ compact: false }), 'bottom-right');

            this.map.on('styleimagemissing', async (e: any) => {
                const url: string = e.id;
                if (!url.startsWith('/api/')) return;
                // Add a transparent placeholder synchronously so Mapbox doesn't log an error
                // for this render cycle. The real image replaces it once the fetch completes.
                if (!this.map.hasImage(url)) {
                    this.map.addImage(url, new ImageData(1, 1), { pixelRatio: 2 });
                }
                try {
                    const response = await fetch(url);
                    if (!response.ok) return;
                    const blob = await response.blob();
                    const bitmap = await createImageBitmap(blob);
                    // Replace placeholder with real image (removeImage handles if it doesn't exist)
                    this.map.removeImage(url);
                    this.map.addImage(url, bitmap as any, { pixelRatio: 2 });
                    this.map.triggerRepaint();
                } catch {}
            });

            this.map.on('contextmenu', (e: any) => {
                this.$emit('rightClick', { x: e.point.x, y: e.point.y, latitude: e.lngLat.lat, longitude: e.lngLat.lng });
            });
            this.map.once('style.load', () => {
                console.warn = _warn;
                if (this.model.mapProvider == 2) this.googleMapsLayer = new GoogleMapsLayer(this, this.satelliteView);
                if (this.model.mapProvider == 3) this.hereMapsLayer = new HereMapsLayer(this, this.satelliteView);
                this.tilesLayer = new TilesLayer(this);
                this.areasLayer = new AreasLayer(this);
                this.cachmentAreaLayer = new CatchmentAreaFeatureLayerHelper(this);
                this.isoLinesLayer = new IsoLinesLayer(this);
                this.areaLayer = new AreaLayer(this);
                this.heatMapLayer = new HeatMapLayer(this);
                this.poisLayer = new PoisLayer(this);
                this.poisInRangeLayer = new PoisInRangeLayer(this);
                this.searchResultsLayer = new SearchResultsLayer(this);
                this.locationsLayer = new LocationsLayer(this);
                this.scenarioLocationsLayer = new ScenarioLocationsLayer(this);
                
                this.modelChanging = false;
                
                this.onLocationsChanged(maintainZoomAndPosition);
                this.onLocationChanged(this.location, null, maintainZoomAndPosition);
                
                this.onPoisChanged();
                this.onLocationCatchmentAreaChanged();
                this.onScenarioLocationsChanged();
                this.onSelectedLocationIsoLines();
                this.onAreaChanged();
                this.onAreaSetVisibleChanged();
                //this.onZoomChanged();
                this.onHeatMapPointsChanged();
                this.onSearchResultsChanged();
                this.map.resize();
            });
            
            this.map.on('moveend', () => {
                // Get the new bounds
                const bounds = this.map.getBounds();
                // Extract coordinates
                const northEast = bounds.getNorthEast();
                const southWest = bounds.getSouthWest();
                // Emit the event with the new bounds
                this.$emit('mapBoundsChanged', {
                    west: southWest.lng,
                    south: southWest.lat,
                    east: northEast.lng,
                    north: northEast.lat
                });
                this.mapStateChanged();
            });
            this.map.on('zoomend', () => {
                this.mapStateChanged();
            });
            this.map.on('rotate', () => {
              this.mapStateChanged();
            });
            this.map.on('pitch', () => {
              this.mapStateChanged();
            });           
        }

        private mapStateChanged()
        {
            const zoom = this.map.getZoom();
            const center = this.map.getCenter();
            const bearing = this.map.getBearing();
            const pitch = this.map.getPitch();
            this.$emit('mapStateChanged', { zoom: zoom, center: center, bearing: bearing, pitch: pitch });
        }
        

        @Watch('locations')
        @Watch('filter')
        @Watch('filterLocations')
        private async onLocationsChangedFromWatch() {
            await this.onLocationsChanged(this.mapState.fromQuery == true);
            this.mapStateChanged();
        }

        private async onLocationsChanged(maintainZoomAndPosition = false)
        {
            if (!this.modelChanging) {
                await this.locationsLayer?.DataChanged(this.leftPadding, this.rightPadding,maintainZoomAndPosition);
            }
        }

        @Watch('poisInRange')
       @Watch('poisInRangeFieldState', { deep: true })
        private onPoisInRangeChanged() {
            if (!this.modelChanging) this.poisInRangeLayer?.DataChanged();
        }

        @Watch('location')
        private onLocationChanged(newLocation: any, oldLocation: any, maintainZoomAndPosition = false)
        {
            if (!this.modelChanging) {
                this.locationsLayer?.SelectLocation(oldLocation?.id, newLocation?.id);
                this.locationsLayer?.AddCircles(newLocation);
                //if (this.report == true) this.map.setCenter(newLocation);
                if (!maintainZoomAndPosition) {
                    if (this.animate) {
                        this.map.flyTo({
                            center: newLocation,
                        });
                    }
                    else {
                        this.map.jumpTo({
                            center: newLocation,
                        });
                    }
                }
            }
        }

        @Watch('pois')
        private onPoisChanged()
        {
            if (!this.modelChanging) this.poisLayer?.DataChanged();
        }

        @Watch('catchmentArea')
        @Watch('locationCatchmentArea')
        private onLocationCatchmentAreaChanged()
        {
            if (!this.modelChanging) this.cachmentAreaLayer?.DataChanged();
        }

        @Watch('scenarioLocationsVisible')
        @Watch('scenarioLocations')
        private onScenarioLocationsChanged()
        {
            if (!this.modelChanging) this.scenarioLocationsLayer?.DataChanged();
        }

        @Watch('locationIsoLines')
        @Watch('isoLineSet')
        @Watch('isoLineMinutes')
        private onSelectedLocationIsoLines()
        {
            if (!this.modelChanging) this.isoLinesLayer?.DataChanged();
        }

        @Watch('area')
        private onAreaChanged()
        {
            if (!this.modelChanging) this.areaLayer?.DataChanged(this.leftPadding, this.rightPadding);
        }

        @Watch('areaSetVisible')
        private onAreaSetVisibleChanged()
        {
            if (!this.modelChanging) this.tilesLayer?.DataChanged();
        }

        @Watch('heatMapPoints')
        private onHeatMapPointsChanged() {
            if (!this.modelChanging) this.heatMapLayer?.DataChanged();
        }

        @Watch('searchResults')
        private onSearchResultsChanged() {
            if (this.modelChanging) return;
            this.searchResultsLayer?.DataChanged();
            if (!this.map || !this.searchResults || this.searchResults.length === 0) return;
            if (this.searchResults.length === 1) {
                const r = this.searchResults[0];
                this.map.flyTo({ center: [r.longitude, r.latitude], zoom: 15 });
                return;
            }
            let minLng = Infinity, minLat = Infinity, maxLng = -Infinity, maxLat = -Infinity;
            for (const r of this.searchResults) {
                if (r.longitude < minLng) minLng = r.longitude;
                if (r.longitude > maxLng) maxLng = r.longitude;
                if (r.latitude < minLat) minLat = r.latitude;
                if (r.latitude > maxLat) maxLat = r.latitude;
            }
            this.map.fitBounds([[minLng, minLat], [maxLng, maxLat]], { padding: 60, maxZoom: 15 });
        }

        @Watch('mapFlyTo')
        private onMapFlyToChanged() {
            if (this.modelChanging || !this.mapFlyTo || !this.map) return;
            this.map.flyTo({
                center: [this.mapFlyTo.longitude, this.mapFlyTo.latitude],
                zoom: this.mapFlyTo.zoom,
            });
            this.$store.commit('main/SET_MAPFLYTO', null);
        }
  }
